<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{initData.pu_code}}&nbsp;#{{initData.pd_detno}}</em>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">采购日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.pu_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">供应商</label>
            <em class="weui-form-preview__value">{{initData.pu_vendname}}</em>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">采购员</label>
            <span class="weui-form-preview__value">{{initData.pu_buyername}}</span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">产品名称</label>
            <span class="weui-form-preview__value">{{initData.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="initData.pr_orispeccode">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{initData.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="initData.pr_spec">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{initData.pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="initData.pr_brand">
            <label class="weui-form-preview__label">品牌</label>
            <span class="weui-form-preview__value">{{initData.pr_brand}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">数量</label>
            <span class="weui-form-preview__value">
              <span v-format="'#,##0.#'">{{initData.pd_qty}}</span>
              &nbsp;
              {{initData.pr_unit}}
            </span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">已入库</label>
            <span class="weui-form-preview__value">
              <span v-format="'#,##0.#'">{{initData.pd_acceptqty}}</span>
              &nbsp;
              {{initData.pr_unit}}
            </span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">需求日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.pd_delivery}}</span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">不含税单价({{initData.pu_currency}})</label>
            <span class="weui-form-preview__value" v-format="'#,##0.####'">{{initData.pd_taxprice}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">含税单价({{initData.pu_currency}})</label>
            <span class="weui-form-preview__value" v-format="'#,##0.####'">{{initData.pd_price}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">不含税金额({{initData.pu_currency}})</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.pd_taxtotal}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">税率(%)</label>
            <span class="weui-form-preview__value">{{initData.pd_taxrate}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">税额({{initData.pu_currency}})</label>
            <span
              class="weui-form-preview__value"
              v-format="'#,##0.00'"
            >{{initData.pd_total-initData.pd_taxtotal}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">价税合计({{initData.pu_currency}})</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.pd_total}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object
  }
};
</script>